import SearchCustomer from './SearchCustomer.vue'
import CustomerTable from './CustomerTable.vue'

export { SearchCustomer, CustomerTable }
